exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.watermark-container[data-v-7890b9e7] {\n  position: fixed;\n  top: -500px;\n  left: -500px;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  pointer-events: none;\n  opacity: 0.2; /* 水印透明度 */\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-line-pack: start;\n      align-content: flex-start;\n  -webkit-transform: rotate(-30deg);\n          transform: rotate(-30deg); /* 倾斜角度 */\n}\n.watermark[data-v-7890b9e7] {\n  width: 300px;\n  height: 200px;\n  font-size: 16px;\n  color: rgba(0, 0, 0, 0.4); /* 水印颜色 */\n}\n", ""]);

// exports
